import {Controller} from '@hotwired/stimulus'
import device from '../../js/device'
import {useIntersection} from 'stimulus-use'
import {hasIntersectionObserver} from "../../js/window-has";

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        counter: Number
    }

    teads = [
        {
            tag: "85484",
            class: "box_banner_center",
        },
        {
            tag: "123155",
            class: "box_banner_center_2",
        },
        {
            tag: "123277",
            class: "box_banner_center_3",
        },

    ];

    connect() {

        if (hasIntersectionObserver()) {
            useIntersection(this, {
                rootMargin: "0px",
            })
        } else {
            this.appear()
        }

        if (device.getType() === 'mobile') {
            this._renderMobile()
        }


        if (device.getType() === 'desktop') {
            this._renderDesktop()
        }

    }


    appear() {

        // when adv appear check if teads made passback only in mobile
        if (this.rendered === true || device.getType() === 'desktop' || this._hasAdv() === false) {
            return
        }

        const e = document.getElementById('div-gpt-ad-1561469327191-0');

        if (e) {
            e.remove();
            this._addDfpTagMobile();
            this.rendered = true;
        }
    }


    _renderMobile() {

        if (this._hasAdv() === false){
            return
        }

        console.log(this.teads[this.counterValue]);

        const e = document.getElementById(`teads-inread-${this.counterValue}`);

        // if element is not in dom and teads tag is defined
        if (!e && this.teads[this.counterValue]) {
            this._addTeadsTag(this.teads[this.counterValue].class, this.teads[this.counterValue].tag, this.counterValue)

        } else {
            this._addDfpTagMobile(Math.floor((Math.random() * 100000)));
        }

    }


    _renderDesktop() {

        if (this._hasAdv() === false){
            return
        }

        // render one adv only
        if (this.counterValue === 2) {
            this._addDfpTagDesktop();
        }

    }


    _addTeadsTag(cl, tag, counter) {
        const container = `<span class="${cl}" ></span>`
        this.element.insertAdjacentHTML('afterbegin', container)
        this.element.setAttribute('id', `teads-inread-${counter}`)

        const s = document.createElement("script")
        const el = document.getElementsByTagName("script")[0]
        s.async = true
        s.src = `//a.teads.tv/page/${tag}/tag`
        el.parentNode.insertBefore(s, el)
    }

    _addDfpTagMobile() {

        const adv = `<div class="text-center bg-adv bg-no-repeat flex items-center justify-start flex-col md:hidden bg-adv-position-default">
            <div
                 id="inread-dfp"     
                 data-controller="adv"
                 data-adv-ad-unit-value="/22272936144/calciomercato/calciomercato_web/articles/middlempu4"
                 data-adv-element-id-value="inread-dfp"
                 data-adv-sizes-value="[300,250]"
                 data-adv-force-value="true" 
                 data-adv-device-value="mobile" 
          ></div>
        </div>`


        this.element.insertAdjacentHTML('afterbegin', adv)

    }

    _addDfpTagDesktop() {

        const adv = `<div class="text-center bg-adv bg-no-repeat flex items-center justify-start flex-col bg-adv-position-default">
            <div
                 id="inread-dfp-desktop" 
                 data-controller="adv"
                 data-adv-ad-unit-value="/22272936144/calciomercato/calciomercato_web/articles/middlempu4"
                 data-adv-element-id-value="inread-dfp-desktop"
                 data-adv-sizes-value="[728,90]"
                 data-adv-force-value="true" 
                 data-adv-device-value="desktop" 
          ></div>
        </div>`

        this.element.insertAdjacentHTML('afterbegin', adv)
    }


    _hasAdv() {
        const e = document.getElementById("has-adv");

        if (e && e.getAttribute('content') === 'false') {

            if (this.element.parentElement.classList.contains("adv")) {
                this.element.parentElement.remove();
            }

            return false;
        }

        return true;
    }

}
